import { https,httpsFile } from "./http";

export function index(page,currentpage,storage_location,matnr){
    return https().get(`po-headers?page=${page}&currentpage=${currentpage}&matnr=${matnr}&storage_location=${storage_location}`);
}


export function showPOAging(page, currentpage,sortby,sortdir, search,days_open, supplier, startDate,endDate,plant,creator) {
    return httpsFile().get(`showPOAging?page=${page}&currentpage=${currentpage}
        &sortby=${sortby}&sortdir=${sortdir}&search=${search}
        &days_open=${days_open}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}&plant=${plant}&creator=${creator}`);
}


export function showPOOpenItems(data) {
    return https().post(`showPOOpenItems`,data);
}


export function showPOOpenItemsLogs(data) {
    return https().post(`showPOOpenItemsLogs`,data);
}

export function exportPOOpenItems(data) {
    return https().post(`exportPOOpenItems`,data);
}

export function showIncomingItemsReport(data) {
    return https().post(`showIncomingItemsReport`,data);
}

export function exportIncomingItemsReport(data) {
    return https().post(`exportIncomingItemsReport`,data);
}


export function updateOpenItems(data) {
    return https().post(`updateOpenItems`,data);
}


export function exportPOAging(page, currentpage,sortby,sortdir, search,days_open, supplier, startDate,endDate,plant,creator) {
    return httpsFile().get(`exportPOAging?page=${page}&currentpage=${currentpage}
        &sortby=${sortby}&sortdir=${sortdir}&search=${search}
        &days_open=${days_open}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}&plant=${plant}&creator=${creator}`);
}

export function showFCPOPerMaterial(option,page = 1) {
    let currentpage = option.per_page;
    let sortby = option.sortby;
    let sortdir = option.sortdir;
    let search = option.search;
    let po_creator = option.po_creator;
    let approved_by = option.approved_by;
    let supplier = option.supplier;
    let matgrp = JSON.stringify(option.matgrp);
    let materials = JSON.stringify(option.materials);
    let show_latest_fc = option.show_latest_fc;
    let is_export = option.is_export;
    return https().get(`fc_po?page=${page}&currentpage=${currentpage}
        &sortby=${sortby}&sortdir=${sortdir}&search=${search}&approved_by=${approved_by}
        &po_creator=${po_creator}&supplier=${supplier}&matgrp=${matgrp}&materials=${materials}&show_latest_fc=${show_latest_fc}&is_export=${is_export}`);
}